import { render, staticRenderFns } from "./PoiSearchResult.vue?vue&type=template&id=11160dfb"
import script from "./PoiSearchResult.vue?vue&type=script&lang=js"
export * from "./PoiSearchResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports